import { Observable } from 'rxjs';
import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';

import { environment } from '../../../environments/environment';

/**
 * A custom HTTP interceptor function that prepends a base URL to outgoing HTTP requests if the request URL does not already start with 'http'.
 *
 * The function checks the provided HTTP request URL and ensures that it includes the `apiBaseUrl` from the application environment settings if it is not an absolute URL. The transformed request is then passed to the next handler in the HTTP pipeline.
 *
 * @param {HttpRequest<unknown>} req - The outgoing HTTP request to be intercepted and potentially modified.
 * @param {HttpHandlerFn} next - The next handler in the HTTP request pipeline.
 * @returns {Observable<HttpEvent<unknown>>} - The observable of the HTTP event representing the response or error, returned from the next handler.
 */
export const baseUrlInterceptor: HttpInterceptorFn = (
	req: HttpRequest<unknown>,
	next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
	if (req.url.startsWith('http')) {
		return next(req);
	}

	const staticAssets = ['/version.json', '/manifest.webmanifest', '/favicon.ico'];
	if (staticAssets.some(asset => req.url.includes(asset))) {
		return next(req);
	}

	const apiReq = req.clone({ url: `${environment.apiBaseUrl}${req.url}` });
	return next(apiReq);
};
